export const project = [
  // { id: 0, label: 'All' },
  { id: 1, label: 'Little Genie' },
  { id: 2, label: 'Classroom' },
  { id: 3, label: 'Foundation' },
  { id: 4, label: 'Speak Pro' },
  { id: 5, label: 'STC' },
  { id: 6, label: 'Other' },
  { id: 7, label: 'Personal Mentor' },
  { id: 8, label: 'NA ' },
  { id: 9, label: 'Open School' },
  { id: 10, label: 'Home School' },
  { id: 11, label: 'Marketing' },
];
